export const GET_LOG_MODIFICACIONES_START = 'GET_LOG_MODIFICACIONES_START';
export const GET_LOG_MODIFICACIONES_ERROR = 'GET_LOG_MODIFICACIONES_ERROR';
export const GET_LOG_MODIFICACIONES_SUCCESS = 'GET_LOG_MODIFICACIONES_SUCCESS';

export const SET_FILTER_PARAMS = 'SET_FILTER_PARAMS';
export const RESET_LOG_MODIFICACIONES_STATE = 'RESET_LOG_MODIFICACIONES_STATE';

export const GET_TRACKING_ORIGINAL_START = 'GET_TRACKING_ORIGINAL_START';
export const GET_TRACKING_ORIGINAL_SUCCESS = 'GET_TRACKING_ORIGINAL_SUCCESS';
export const GET_TRACKING_ORIGINAL_ERROR = 'GET_TRACKING_ORIGINAL_ERROR';